/* ===========================================================================
   <video-reels-slider>
   ---------------------------------------------------------------------------
   Horizontal Swiper of vertical product video reels (PDP block). Ported from
   thecottonliving theme into Impulse.

   - Swiper for the horizontal strip (uses the theme's global swiper-bundle).
   - IntersectionObserver autoplays muted reels only while in view.
   - Click a reel → opens a portrait modal player with controls/sound.
   Registration is guarded so theme-editor reloads don't double-define it.
   =========================================================================== */
(function () {
  if (typeof customElements === 'undefined') return;
  if (customElements.get('video-reels-slider')) return;

  class VideoReelsSlider extends HTMLElement {
    connectedCallback() {
      this.swiperContainer = this.querySelector('.swiper');
      this.modal = this.querySelector('.reel-video-modal');
      this.modalPlayer = this.querySelector('.reel-modal-player');
      this.closeBtn = this.querySelector('.reel-video-modal-close');
      this.overlay = this.querySelector('.reel-video-modal-overlay');
      this.videos = this.querySelectorAll('.reel-video[data-autoplay="true"]');

      this.initSwiper();
      this.initObserver();
      this.initModalEvents();
    }

    initSwiper() {
      if (!this.swiperContainer) return;
      if (this.swiperContainer.classList.contains('swiper-initialized')) return;

      var attempts = 0;
      var init = function () {
        if (typeof window.Swiper !== 'undefined') {
          this.swiperInstance = new window.Swiper(this.swiperContainer, {
            slidesPerView: 3.2,
            spaceBetween: 8,
            grabCursor: true,
            breakpoints: {
              1024: { slidesPerView: 4.3, spaceBetween: 10 }
            }
          });
        } else if (attempts < 50) {
          attempts++;
          setTimeout(init, 100);
        }
      }.bind(this);

      init();
    }

    initObserver() {
      if (!('IntersectionObserver' in window) || this.videos.length === 0) return;

      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.5 });

      this.videos.forEach(function (vid) { this.observer.observe(vid); }.bind(this));
    }

    initModalEvents() {
      if (!this.modal || !this.modalPlayer) return;

      this.querySelectorAll('.reel-video-container').forEach(function (container) {
        container.addEventListener('click', function () {
          var clicked = container.querySelector('video');
          if (!clicked) return;

          this.modalPlayer.poster = clicked.poster;
          this.modalPlayer.innerHTML = clicked.innerHTML;
          this.modalPlayer.muted = false;
          this.modalPlayer.load();

          this.modal.classList.add('is-active');
          this.modal.setAttribute('aria-hidden', 'false');
          this.modalPlayer.play().catch(function () {});
        }.bind(this));
      }.bind(this));

      var close = function () {
        this.modal.classList.remove('is-active');
        this.modal.setAttribute('aria-hidden', 'true');
        this.modalPlayer.pause();
        this.modalPlayer.innerHTML = '';
        this.modalPlayer.load();
      }.bind(this);

      if (this.closeBtn) this.closeBtn.addEventListener('click', close);
      if (this.overlay) this.overlay.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && this.modal.classList.contains('is-active')) close();
      }.bind(this));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.swiperInstance) this.swiperInstance.destroy(true, true);
    }
  }

  customElements.define('video-reels-slider', VideoReelsSlider);
})();
